import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class PublicOperationsServiceService {
  user = new BehaviorSubject(null);

  constructor(private http: HttpClient) { }

  getUser(): Observable<any> {
    return this.user.asObservable();
  }

  saveUser(user) {
    this.user.next(user);
  }

  getAuthHeaders(): HttpHeaders {
    const token = this.getPublicToken();
    if (!token) {
      throw new Error('No authentication token available');
    }
    return new HttpHeaders({
      'Authorization': `JWT ${token}`,
      'Content-Type': 'application/json'
    });
  }
  setToken(data: any): void {
    try {
      localStorage.setItem('public-token', JSON.stringify(data));
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  getPublicToken(): string | null {
    try {
      // Return the token directly as string
      return JSON.parse(localStorage.getItem('public-token'));

    } catch (e) {
      console.error('Error getting public-token from localStorage', e);
      return null;
    }
  }
  getOperationTripsByToken(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get<any>(urls.BASE_URL + urls.GET_TRANSPORT_URL, { headers }).pipe(
      catchError(errorHandl)
    );
  }

  VerifyTokenModified(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get<any>(urls.BASE_URL + urls.PROFILE_URL, { headers }).pipe(
      catchError(errorHandl)
    );
  }

  getSpaceTypesWithToken(queryParams): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    const headers = this.getAuthHeaders();
    return this.http.get<any>(urls.BASE_URL + urls.SPACE_TYPE_URL, {
      params,
      headers
    }).pipe(
      catchError(errorHandl)
    );
  }

  removeToken(): void {
    try {
      localStorage.removeItem('public-token');
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }
}
